import MineDamageLogic from "../../../logic/MineDamageLogic";
import TileMinedLogic from "../../../logic/TileMinedLogic";
import VectorField from "../../grid/VectorField";
import StatisticsIncrementor from "../../statistics/StatisticsIncrementor";
import Character from "../Character";
import MoveTurnAction from "./MoveTurnAction";

export default class PartyMoveTurnAction extends MoveTurnAction {
    /**
     * @param {StatisticsIncrementor} statisticsIncrementor 
     * @param {MineDamageLogic} mineDamageLogic
     * @param {TileMinedLogic} tileMinedLogic
     * @param {VectorField} vectorField
     */
    constructor(statisticsIncrementor, mineDamageLogic, tileMinedLogic, vectorField) {
        super();

        /**
         * @constant
         * @type {StatisticsIncrementor}
         */
        this.statisticsIncrementor = statisticsIncrementor;
        /**
         * @constant
         * @type {MineDamageLogic}
         */
        this.mineDamageLogic = mineDamageLogic;
        /**
         * @constant
         * @type {TileMinedLogic}
         */
        this.tileMinedLogic = tileMinedLogic;
        /**
         * @constant
         * @type {VectorField}
         */
        this.vectorField = vectorField;

    }

    /**
     * @override
     * @param {Character} character The character making the turn action.
     * @param {number} frameTimeRatio The time frame ratio.
     * @param {boolean} turnStart True if this is the start of a turn.
     */
    performAction(character, frameTimeRatio, turnStart) {
        //////////////////////////////////////
        if (character.position.tile && !character.position.tile.open && this.vectorField.tileHealthNegligible) {
            this.tileMinedLogic.mineTileIstantly(character, character.position.tile);
        }
        //////////////////////////////////////

        super.performAction(character, frameTimeRatio, turnStart);

        const tile = character.position.tile;
        if (!tile) {
            return;
        }

        //////////////////////////////////////
        if (!tile.open && this.vectorField.tileHealthNegligible) {
            this.tileMinedLogic.mineTileIstantly(character, tile);
        }
        //////////////////////////////////////

        // Update max depth statistics and possibly total damage.

        const maxDepthBefore = this.statisticsIncrementor.globalStatitics.maxDepth;
        const depth = tile.getTileRow();

        this.statisticsIncrementor.tileDepth(depth);

        // If we have a new max depth, then recalculate the damage.
        if (maxDepthBefore < depth) {
            this.mineDamageLogic.calculateTotalMineDamagePerTurn();
        }
    }
}